import React from "react";
import PropTypes from "prop-types";

const ProfileSocial = ({ profile }) => (
  <div className="profile-right-nav profile-social">
    <h3>Social Links</h3>
    <div>
      {profile.social.soundcloud && profile.social.soundcloud !== "undefined" && (
        <div>
          Soundcloud:{" "}
          <a href={`http://soundcloud.com/${profile.social.soundcloud}`} target="_blank" rel="noopener noreferrer">
            @{profile.social.soundcloud}
          </a>
        </div>
      )}
      {profile.social.twitter && profile.social.twitter !== "undefined" && (
        <div>
          Twitter:{" "}
          <a href={`http://twitter.com/${profile.social.twitter}`} target="_blank" rel="noopener noreferrer">
            @{profile.social.twitter}
          </a>
        </div>
      )}
      {profile.social.discogs && profile.social.twitter !== "undefined" && (
        <div>
          Discogs:{" "}
          <a href={`http://discogs.com/user/${profile.social.discogs}`} target="_blank" rel="noopener noreferrer">
            @{profile.social.discogs}
          </a>
        </div>
      )}
      {profile.social.instagram && profile.social.instagram !== "undefined" && (
        <div>
          Instagram:{" "}
          <a href={`http://instagram.com/${profile.social.instagram}`} target="_blank" rel="noopener noreferrer">
            @{profile.social.instagram}
          </a>
        </div>
      )}
    </div>
  </div>
);

export default ProfileSocial;
